// firebaseClient.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDOfXGBp9kE2FZ_DdTOnJPjdLwqMworN1I",
  authDomain: "sowash-firebase-project.firebaseapp.com",
  projectId: "sowash-firebase-project",
  storageBucket: "sowash-firebase-project.firebasestorage.app",
  messagingSenderId: "566792530039",
  appId: "1:566792530039:web:16f1c9b4e76ef0afebbe72",
  measurementId: "G-0K1D3GCHXP"
};
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
